<div>
    <div class="trip-header" style="display: flex; justify-content: center; align-items: center; margin-bottom: 20px; position: relative;">
        <h2 data-testid="trip-details-title" class="page-details-title-style">Trip {{data.tripId}}</h2>
        
        <button
            *ngIf="this.isHackathonTravelTipsActionEnabled"
            mat-raised-button
            color="accent"
            (click)="showWeatherRisk()"
            style="position: absolute; right: 170px;"
            data-testid="show-weather-risk-button">
            <mat-icon>cloud</mat-icon>
            Travel Tips
        </button>
        
        <button
            *ngIf="loggedInUserHasDirectorOrFinanceOrManagerRole()"
            mat-raised-button
            color="primary"
            (click)="generatePdf()"
            [disabled]="isGeneratingPdf"
            style="position: absolute; right: 0;"
            data-testid="generate-pdf-button">
            <mat-icon *ngIf="!isGeneratingPdf">picture_as_pdf</mat-icon>
            {{ isGeneratingPdf ? 'Generating Pdf...' : 'Generate Pdf' }}
        </button>
    </div>
</div>



<app-trip-info *ngIf="tripData$ | async as data" [data]="data"></app-trip-info>

<adx-invoice-list *ngIf="tripData$ | async as data" [data]="data"></adx-invoice-list>

<adx-invoice-erp-adjustment-list *ngIf="tripData$ | async as data" [data]="data"></adx-invoice-erp-adjustment-list>

<br>
<app-adx-payment-grid *ngIf="tripData$ | async as data" [data]="data"></app-adx-payment-grid>

<adx-booking-to-trams-invoice-link-list *ngIf="tripData$ | async as data" [data]="data"></adx-booking-to-trams-invoice-link-list>
